import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "cache_failed",
  "use": "cache_failed-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"cache_failed\"><path d=\"M3.943 8.112 14.447 18H5a5 5 0 0 1-1.057-9.888ZM10 2c3.314 0 6 3.134 6 7 0 .34-.02.676-.061 1.004L16 10a4 4 0 0 1 1.177 7.824L4.588 5.974C5.556 3.624 7.615 2 10 2Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol